'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const $ = require("jquery");
class Modal {
    constructor() {
        $('.trigOpenModal').on('click', () => {
            $('.bulletModalImage').fadeIn('slow');
        });
        $('.trigCloseModal').on('click', function (event) {
            if (!$(event.target).closest('.paramModalImage').length) {
                $('.bulletModalImage').fadeOut('slow');
            }
        });
    }
}
exports.Modal = Modal;
exports.default = Modal;
